







import { Component, Mixins, Prop } from 'vue-property-decorator'
import BaseComponent from '@/tcw/components/BaseComponent'

@Component
export default class ShouninComment extends Mixins(BaseComponent) {
  @Prop({ default: '' })
  protected comment!: string

  get shouninCommentCardStyle(): { [key: string]: string } {
    return { padding: '0.6rem 1rem' }
  }
}
